// HTTP Client - direct re-exports for optimal tree-shaking
export {HttpClient, type HttpClientConfig, type HttpClientInstance, type RequestConfig} from "./http-client";
// HTTP Client Factory (Next.js only - uses next-runtime-env)
export {createApiClient} from "./create-api-client";

// HTTP Exceptions - direct re-exports
export {
    HttpException,
    BadRequestException,
    UnauthorizedException,
    ForbiddenException,
    NotFoundException,
    MethodNotAllowedException,
    ConflictException,
    UnprocessableEntityException,
    InternalServerErrorException,
    BadGatewayException,
    ServiceUnavailableException,
    GatewayTimeoutException,
} from "./exceptions";
